{
  "mapping": [
    "Base64",
    "ImportValue"
  ],
  "scalar": [
    "Ref",
    "Sub",
    "GetAZs",
    "GetAtt",
    "Condition",
    "ImportValue",
    "Cidr"
  ],
  "sequence": [
    "And",
    "Equals",
    "GetAtt",
    "If",
    "FindInMap",
    "Join",
    "Not",
    "Or",
    "Select",
    "Sub",
    "Split",
    "Cidr"
  ]
}
